(function () {
  var configEl = document.querySelector('[data-lc-combo-config]');
  var bundleVariants = [];
  if (configEl) {
    try {
      bundleVariants = JSON.parse(configEl.textContent).variants || [];
    } catch (e) {
      bundleVariants = [];
    }
  }

  var sizeGroups = document.querySelectorAll('.js-lc-combo-size-group');
  var errorEl = document.querySelector('.js-lc-combo-error');

  function optionKey(index) {
    return 'option' + (index + 1);
  }

  function selectedValue(group) {
    var active = group.querySelector('.js-lc-combo-size-btn.is-selected');
    return active ? active.getAttribute('data-value') : null;
  }

  function findBundleVariant() {
    if (!sizeGroups.length) return null;
    var selection = {};
    sizeGroups.forEach(function (group) {
      var key = optionKey(Number(group.getAttribute('data-option-index')));
      selection[key] = selectedValue(group);
    });
    return bundleVariants.find(function (variant) {
      return Object.keys(selection).every(function (key) {
        return variant[key] === selection[key];
      });
    }) || null;
  }

  function syncButtons() {
    if (!sizeGroups.length) return;
    var variant = findBundleVariant();
    var available = !!variant && variant.available;
    document.querySelectorAll('.js-lc-combo-add').forEach(function (b) {
      b.setAttribute('data-bundle-variant', variant ? variant.id : '');
      b.disabled = !available;
    });
    if (errorEl) {
      if (!available) {
        errorEl.textContent = 'That size combo is currently unavailable.';
        errorEl.hidden = false;
      } else {
        errorEl.hidden = true;
      }
    }
  }

  sizeGroups.forEach(function (group) {
    group.querySelectorAll('.js-lc-combo-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        group.querySelectorAll('.js-lc-combo-size-btn').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        syncButtons();
      });
    });
  });
  syncButtons();

  function addComboToCart(button) {
    var bundleVariant = button.getAttribute('data-bundle-variant');
    var label = button.querySelector('.js-lc-combo-add-label');
    if (!bundleVariant) return;

    var originalText = label ? label.textContent : '';
    document.querySelectorAll('.js-lc-combo-add').forEach(function (b) { b.disabled = true; });
    if (label) label.textContent = 'ADDING…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(bundleVariant), quantity: 1 }
        ]
      })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Could not add to cart'); });
        return res.json();
      })
      .then(function () {
        window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart'
          : '/cart';
      })
      .catch(function (err) {
        document.querySelectorAll('.js-lc-combo-add').forEach(function (b) { b.disabled = false; });
        if (label) label.textContent = originalText;
        if (errorEl) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        }
      });
  }

  document.querySelectorAll('.js-lc-combo-add').forEach(function (btn) {
    btn.addEventListener('click', function () { addComboToCart(btn); });
  });

  var stickyBar = document.querySelector('.js-lc-sticky');
  var heroButton = document.querySelector('.lc-lhero__button');
  var footer = document.querySelector('.lc-footer, footer');

  if (stickyBar && heroButton) {
    var showObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
        });
      },
      { rootMargin: '-80px 0px 0px 0px' }
    );
    showObserver.observe(heroButton);

    if (footer) {
      var hideObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) stickyBar.hidden = true;
          });
        },
        { rootMargin: '0px' }
      );
      hideObserver.observe(footer);
    }
  }
})();
